import {
  HasuraDataTableColumnDef,
  DataTableEx,
  DataTableExProps,
  DataTableExRef,
  FormInput,
} from '@kirz/mui-admin';
import React, {
  forwardRef,
  Ref,
  useImperativeHandle,
  useMemo,
  useRef,
} from 'react';

export const UsersTable = forwardRef(
  (
    props: Partial<DataTableExProps> & {
      id: string;
      filterColumns?: (
        columns: HasuraDataTableColumnDef[],
      ) => HasuraDataTableColumnDef[];
    },
    ref: Ref<DataTableExRef>,
  ) => {
    const { filterColumns, ...rest } = props;

    const tableRef = useRef<DataTableExRef>(null);

    useImperativeHandle(ref, () => tableRef.current!, []);

    const columns = useMemo<HasuraDataTableColumnDef[]>(
      () =>
        (filterColumns || ((x: HasuraDataTableColumnDef[]) => x))([
          {
            field: 'name',
            headerName: 'Naam',
            flex: 1,
          },
          {
            field: 'email',
            headerName: 'E-mail',
            flex: 1,
            type: 'email',
          },
          {
            field: 'phone',
            headerName: 'Telefoon',
            flex: 1,
            type: 'phone',
          },
          {
            field: 'apiToken',
            headerName: 'API-sleutel',
            flex: 1,
          },
          { field: 'createdAt', headerName: 'Aangemaakt op', type: 'date' },
        ]),
      [filterColumns],
    );

    return (
      <DataTableEx
        {...rest}
        ref={tableRef}
        source="user"
        columns={columns}
        persistStateMode="query"
        sortBy={rest.sortBy ?? { field: 'createdAt', sort: 'desc' }}
        editable={{
          onEdit(row) {
            tableRef.current?.openFormDialog(row);
          },
        }}
        formTitle={(isNew) =>
          isNew ? 'Gebruiker toevoegen' : 'Gebruiker Aanpassen'
        }
        formDialogProps={{
          ...rest.formDialogProps,
          maxWidth: 'sm',
        }}
      >
        <FormInput name="name" label="Naam" md={6} required />
        <FormInput name="email" label="E-mail" type="email" md={6} required />
        <FormInput name="phone" label="Telefoon" type="phone" md={6} />
      </DataTableEx>
    );
  },
);
